import { css } from '@corti/style';
import { getBaseCss } from 'lib/cortiUI/components/baseHoc';
import { getInputFocusCss } from '../TextField';
export function getRichTextInputStyles({ theme }) {
    return css(getBaseCss({ p: 4, borderRadius: 2 }, theme), getInputFocusCss({ theme }));
}
